// @flow strict

export const resolveSearchBackend = (value = process.env.SEARCH_BACKEND) => {
  const backend = value || 'algolia';
  if (backend !== 'algolia' && backend !== 'typesense') {
    throw new Error('SEARCH_BACKEND must be algolia or typesense');
  }
  return backend;
};

export const SEARCH_BACKEND = resolveSearchBackend();
export const SEARCH_API_PATH = '/api/search';

// This public identifier pins browser calls to the dataset used to render HTML.
// It is assigned only after the renderer bootstrap validates the immutable manifest.
export const resolveCatalogGeneration = (value = process.env.SEARCH_CATALOG_GENERATION) => {
  if (value === undefined || value === '') return '';
  if (typeof value !== 'string' || !/^[a-z0-9_]{1,160}$/.test(value)) {
    throw new Error('Invalid SEARCH_CATALOG_GENERATION');
  }
  return value;
};
export const SEARCH_CATALOG_GENERATION = resolveCatalogGeneration();
